import { clsx } from 'clsx';
import { ImgHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';

export const Image = forwardRef<
  HTMLImageElement,
  ImgHTMLAttributes<HTMLImageElement>
>(({ src, alt, onClick, className }, ref) => {
  return (
    <img
      src={src}
      alt={alt || ''}
      onClick={onClick}
      loading="lazy"
      role="img"
      className={clsx(styles.img, className)}
      {...(ref ? { ref } : {})}
    />
  );
});
